<template>
  <div class="modal fade show" style="display: block;" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-info-circle me-2"></i>
            Closure Request Details
          </h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        
        <div class="modal-body">
          <div class="row">
            <!-- Basic Information -->
            <div class="col-md-6">
              <h6 class="text-primary mb-3">
                <i class="fa fa-file-text me-1"></i>
                Request Information
              </h6>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Log Number:</label>
                <p class="mb-1">{{ request.subCategoryLogNo }}</p>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">SubCategory:</label>
                <p class="mb-1">{{ request.subCategoryId?.name || request.subCategoryName || 'N/A' }}</p>
                <small class="text-muted">Category: {{ request.subCategoryId?.CategoryId?.name || 'N/A' }}</small>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Category Type:</label>
                <p class="mb-1">
                  <span class="badge bg-secondary">
                    {{ request.subcategoryDetails?.subCategoryInfo?.categoryType?.toUpperCase() || 'N/A' }}
                  </span>
                </p>
              </div>
              
            
              
              <div class="mb-3">
                <label class="form-label fw-bold">Status:</label>
                <p class="mb-1">
                  <span 
                    class="badge"
                    :class="getStatusClass(request.status)"
                  >
                    {{ request.status?.toUpperCase() || 'PENDING' }}
                  </span>
                </p>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Created Date:</label>
                <p class="mb-1">{{ formatDate(request.createdAt) }}</p>
              </div>

           
            </div>
            
            <!-- Site & Manager Information -->
            <div class="col-md-6">
              <h6 class="text-primary mb-3">
                <i class="fa fa-building me-1"></i>
                Site Information
              </h6>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Site Name:</label>
                <p class="mb-1">{{ request.subcategoryDetails?.siteInformation?.siteName || request.kytOperationId?.siteName || 'N/A' }}</p>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Site Address:</label>
                <p class="mb-1">{{ request.subcategoryDetails?.siteInformation?.siteAddress || request.kytOperationId?.siteAddress || 'N/A' }}</p>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">Assigned Manager:</label>
                <p class="mb-1">
                  <strong>{{ request.subcategoryDetails?.siteInformation?.kytDetails?.assignedManager?.name || request.kytOperationId?.empId?.employeeName || 'N/A' }}</strong>
                </p>
                <small class="text-muted">Code: {{ request.subcategoryDetails?.siteInformation?.kytDetails?.assignedManager?.code || request.kytOperationId?.empId?.employeeCode || 'N/A' }}</small>
              </div>
              
              <div class="mb-3">
                <label class="form-label fw-bold">KYT Status:</label>
                <p class="mb-1">
                  <span class="badge bg-success">
                    {{ request.subcategoryDetails?.siteInformation?.kytDetails?.status?.toUpperCase() || request.kytOperationId?.status?.toUpperCase() || 'N/A' }}
                  </span>
                </p>
              </div>
              
            

              <div class="mb-3">
                <label class="form-label fw-bold">NFD :</label>
                <p class="mb-1">{{ formatDate(request.subcategoryDetails?.siteInformation?.kytDetails?.NFD || request.kytOperationId?.NFD) }}</p>
              </div>
            </div>
          </div>

        
          
          <!-- Assigned Employees -->
          <div class="row mt-3" v-if="request.subcategoryDetails?.assignedEmployees?.length">
            <div class="col-12">
              <h6 class="text-primary mb-3">
                <i class="fa fa-users me-1"></i>
                Assigned Employees ({{ request.subcategoryDetails.assignedEmployees.length }})
              </h6>
              
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <thead class="bg-light">
                    <tr>
                      <th>Assignment ID</th>
                      <th>Employee</th>
                      <th>Action</th>
                      <th>Status</th>
                      <th>Assigned Date</th>
                      <th>Assigned By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="assignment in request.subcategoryDetails.assignedEmployees" :key="assignment.assignmentId">
                      <td>
                        <code>{{ assignment.assignmentId }}</code>
                      </td>
                      <td>
                        <strong>{{ assignment.employee?.name || 'N/A' }}</strong>
                        <br>
                        <small class="text-muted">{{ assignment.employee?.code || 'N/A' }}</small>
                      </td>
                      <td>
                        <span class="badge" :class="{
                          'bg-danger': assignment.workDetails?.action === 'penalty',
                          'bg-warning': assignment.workDetails?.action === 'warning',
                          'bg-secondary': assignment.workDetails?.action === 'suspension'
                        }">
                          {{ assignment.workDetails?.action?.toUpperCase() || 'N/A' }}
                        </span>
                        <div v-if="assignment.workDetails?.penalty > 0" class="mt-1">
                          <small class="text-danger">Penalty: ₹{{ assignment.workDetails?.penalty }}</small>
                        </div>
                        <div class="mt-1">
                          <small class="text-muted">Priority: {{ assignment.workDetails?.priority || 'N/A' }}</small>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex flex-column gap-1">
                          <span class="badge" :class="assignment.status?.isCompletedWork ? 'bg-success' : 'bg-secondary'">
                            {{ assignment.status?.isCompletedWork ? 'COMPLETED' : 'PENDING' }}
                          </span>
                          <span class="badge" :class="assignment.status?.workStarted ? 'bg-info' : 'bg-light text-dark'">
                            {{ assignment.status?.workStarted ? 'STARTED' : 'NOT STARTED' }}
                          </span>
                          <span v-if="assignment.status?.isVerified" class="badge bg-primary">VERIFIED</span>
                          <span v-if="assignment.status?.isSubmit" class="badge bg-success">SUBMITTED</span>
                        </div>
                      </td>
                      <td>{{ formatDate(assignment.dates?.assignedDate) }}</td>
                      <td>
                        <strong>{{ assignment.assignedBy?.name || 'N/A' }}</strong>
                        <br>
                        <small class="text-muted">{{ assignment.assignedBy?.code || 'N/A' }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Images Section -->
          <div class="row mt-3" v-if="request.subcategoryDetails?.subCategoryInfo?.images?.length">
            <div class="col-12">
              <h6 class="text-primary mb-3">
                <i class="fa fa-image me-1"></i>
                SubCategory Images ({{ request.subcategoryDetails.subCategoryInfo.images.length }})
              </h6>
              
              <div class="row">
                <div 
                  v-for="(image, index) in request.subcategoryDetails.subCategoryInfo.images" 
                  :key="index"
                  class="col-md-4 col-sm-6 mb-3"
                >
                  <div class="card">
                    <img 
                      :src="image" 
                      class="card-img-top" 
                      style="height: 200px; object-fit: cover; cursor: pointer;"
                      :alt="`SubCategory Image ${index + 1}`"
                      @click="openImageModal(image)"
                    >
                    <div class="card-body p-2">
                      <small class="text-muted">Image {{ index + 1 }}</small>
                      <div class="mt-1">
                        <a :href="image" target="_blank" class="btn btn-sm btn-outline-primary">
                          <i class="fa fa-external-link me-1"></i>
                          View Full Size
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Assignment Photos -->
          <div class="row mt-3" v-if="hasAssignmentPhotos">
            <div class="col-12">
              <h6 class="text-primary mb-3">
                <i class="fa fa-camera me-1"></i>
                Assignment Photos
              </h6>
              
              <div v-for="assignment in request.subcategoryDetails?.assignedEmployees" :key="assignment.assignmentId">
                <div v-if="assignment.photos?.length" class="mb-4">
                  <h6 class="text-secondary mb-2">{{ assignment.employee?.name || 'N/A' }} ({{ assignment.assignmentId }})</h6>
                  <div class="row">
                    <div 
                      v-for="(photo, index) in assignment.photos" 
                      :key="index"
                      class="col-md-3 col-sm-6 mb-2"
                    >
                      <div class="card">
                        <img 
                          :src="photo" 
                          class="card-img-top" 
                          style="height: 150px; object-fit: cover; cursor: pointer;"
                          :alt="`${assignment.employee?.name || 'Employee'} Photo ${index + 1}`"
                          @click="openImageModal(photo)"
                        >
                        <div class="card-body p-1">
                          <small class="text-muted">Photo {{ index + 1 }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


      
          
          <!-- SubCategory Log Information -->
          <div class="row mt-3" v-if="request.subCategoryDetails">
            <div class="col-12">
              <h6 class="text-primary mb-3">
                <i class="fa fa-list me-1"></i>
                SubCategory Log Details
              </h6>
              
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <tbody>
                    <tr>
                      <td class="fw-bold bg-light">Current Status:</td>
                      <td>{{ request.subCategoryDetails?.status || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold bg-light">Site:</td>
                      <td>{{ request.subCategoryDetails?.site?.name || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold bg-light">Created Date:</td>
                      <td>{{ formatDate(request.subCategoryDetails?.createdAt) }}</td>
                    </tr>
                    <tr>
                      <td class="fw-bold bg-light">Last Updated:</td>
                      <td>{{ formatDate(request.subCategoryDetails?.updatedAt) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <!-- Attachments -->
          <div class="row mt-3" v-if="request.attachments && request.attachments.length > 0">
            <div class="col-12">
              <h6 class="text-primary mb-3">
                <i class="fa fa-paperclip me-1"></i>
                Attachments
              </h6>
              
              <div class="d-flex flex-wrap gap-2">
                <a 
                  v-for="attachment in request.attachments" 
                  :key="attachment._id"
                  :href="attachment.url" 
                  target="_blank"
                  class="btn btn-outline-primary btn-sm"
                >
                  <i class="fa fa-download me-1"></i>
                  {{ attachment.filename }}
                </a>
              </div>
            </div>
          </div>
          
          <!-- Admin Notes -->
          <div class="row mt-3" v-if="request.adminNotes">
            <div class="col-12">
              <h6 class="text-info mb-3">
                <i class="fa fa-sticky-note me-1"></i>
                Admin Notes
              </h6>
              
              <div class="border rounded p-3 bg-info bg-opacity-10">
                {{ request.adminNotes }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            <i class="fa fa-times me-1"></i>
            Close
          </button>
          
          <button 
            type="button" 
            class="btn btn-success" 
            @click="$emit('approve', request)"
          >
            <i class="fa fa-check me-1"></i>
            Approve Request
          </button>
          
          <button 
            type="button" 
            class="btn btn-danger" 
            @click="$emit('reject', request)"
          >
            <i class="fa fa-times me-1"></i>
            Reject Request
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal backdrop -->
  <div class="modal-backdrop fade show"></div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import { formatDate, PRIORITY_CONFIG } from '@/services/subcategoryClosureService';

// Props
const props = defineProps({
  request: {
    type: Object,
    required: true
  }
});

// Emits
const emit = defineEmits(['close', 'approve', 'reject']);

// Computed properties
const hasAssignmentPhotos = computed(() => {
  return props.request.subcategoryDetails?.assignedEmployees?.some(
    assignment => assignment.photos && assignment.photos.length > 0
  ) || false;
});

// Methods
const getPriorityClass = (priority) => {
  return PRIORITY_CONFIG[priority]?.class || PRIORITY_CONFIG.medium.class;
};

const getStatusClass = (status) => {
  const statusConfig = {
    pending: 'bg-warning text-dark',
    approved: 'bg-success',
    rejected: 'bg-danger',
    cancelled: 'bg-secondary'
  };
  return statusConfig[status] || 'bg-warning text-dark';
};

const getProgressBarClass = (percentage) => {
  if (percentage === 0) return 'bg-secondary';
  if (percentage < 25) return 'bg-danger';
  if (percentage < 50) return 'bg-warning';
  if (percentage < 75) return 'bg-info';
  return 'bg-success';
};

const openImageModal = (imageUrl) => {
  // Open image in a new window/tab
  window.open(imageUrl, '_blank');
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1050;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.form-label.fw-bold {
  color: #495057;
  margin-bottom: 0.5rem;
}

.border {
  border-color: #dee2e6 !important;
}

.text-primary {
  color: #3e5fce !important;
}

.text-info {
  color: #17a2b8 !important;
}

/* Timeline styles */
.timeline {
  position: relative;
}

.timeline-item {
  position: relative;
}

.timeline-marker {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
}

.timeline-marker::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 12px;
  width: 2px;
  height: 50px;
  background-color: #dee2e6;
  transform: translateX(-50%);
}

.timeline-item:last-child .timeline-marker::before {
  display: none;
}

/* Progress bar */
.progress {
  border-radius: 10px;
}

.progress-bar {
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.75rem;
}

/* Image hover effects */
.card img:hover {
  opacity: 0.8;
  transform: scale(1.02);
  transition: all 0.2s ease;
}

/* Summary cards */
.card h4 {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.card small {
  font-size: 0.75rem;
  opacity: 0.9;
}

/* Badge spacing */
.badge + .badge {
  margin-left: 0.25rem;
}

/* Table improvements */
.table-sm th,
.table-sm td {
  padding: 0.5rem;
  font-size: 0.875rem;
}

.table code {
  font-size: 0.8rem;
  background-color: #f8f9fa;
  color: #e83e8c;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
  }
  
  .card-body {
    padding: 1rem;
  }
  
  .table-responsive {
    font-size: 0.8rem;
  }
}
</style>